var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLargeScreen)?_c('HeaderDesktop',{on:{"logout":_vm.logout}}):_c('HeaderMobile',{on:{"scrollTop":_vm.scrollTop,"logout":_vm.logout}})
}
var staticRenderFns = []

export { render, staticRenderFns }